<div class="content">
  <img
    class="background"
    src="../../../../assets/images/check-fleet-node.webp"
    alt=""
  />
  <div class="title">选择节点进入车队</div>
  <div class="subtitle">请先选择节点，才能正常发起对话</div>
  <div class="checks">
    <div
      *ngFor="let item of list"
      class="check"
      (click)="checkNode(item.id)"
      [ngStyle]="{ background: item.check ? '#01C6B4  ' : '#ffffff' }"
    >
      <div class="left">
        <img
          src="../../../../assets/images/Icon-node.svg"
          [ngClass]="item.check ? 'active' : 'inactive'"
          [width]="18"
          [height]="18"
          alt=""
        />

        <span>
          <div
            class="name"
            [ngStyle]="{ color: item.check ? '#FFFFFF ' : '#000000' }"
          >
            {{ item.name }}
          </div>
          <div
            class="time"
            [ngStyle]="{ color: item.check ? '#FFFFFF ' : '#01c6b4' }"
          >
            {{ item.time }}
          </div>
        </span>
      </div>
      <div class="right" *ngIf="item.check">
        <img
          src="../../../../assets/images/Icon-right.svg"
          [width]="20"
          [height]="20"
          alt=""
        />
      </div>
    </div>
  </div>
  <div class="button">
    <button (click)="onOk()">确认连接</button>
  </div>
</div>
